//
// Module for Reporting Configuration Edit view
//
rs.module("fund/configuration/employerreporting/index",

    ["controls/data/grid"],

    function (gridModule) {
        // Initialize the module
        function initialize(lrsGridApi, jsSelectors, backendUrl) {
            var form = $.js(jsSelectors.filterForm);
            var employerSelect = form.js(jsSelectors.employerSelect);
            var loadingSpinner = form.js(jsSelectors.loadingSpinner);

            employerSelect.change(employerChanged);

            // Reload the grid data when the employer is changed
            function employerChanged() {
                loadingSpinner.show();

                gridModule.update(
                    backendUrl,

                    { orgRefNum: employerSelect.val() },

                    lrsGridApi.agGridApi,

                    function done() {
                        loadingSpinner.hide();
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);